<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body
          p 新增藥物群組
            span.icon-right(@click="$emit('closeForm')") X
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 名稱*
              input.form-control(v-model="name")
          hr
          span.errorMsg {{ formMsg }}
          button.btn.btn-secondary.float-right(
            :disabled="formComplete === false"
            @click.prevent="createMedGroup"
            ) 新增
</template>

<script>
export default {
  name: 'CreateUserForm',
  data() {
    return {
      name: '',
      formMsg: '請填入所有資訊以新增',
    };
  },
  created() {
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    formComplete() {
      if (this.name === '') return false;
      return true;
    },
  },
  methods: {
    createMedGroup() {
      if (this.formComplete) {
        this.instance.post('/api/medication-group/', {
          name: this.name,
        })
        .then(() => {
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增成功',
          });
          this.$emit('dataCreated');
          this.$parent.$refs.vuetable.refresh();
        })
        .catch((err) => {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: err.response.data,
          });
        });
      }
    },
  },
};
</script>

<style lang="sass">

.errorMsg
  color: red
</style>




// WEBPACK FOOTER //
// CreateDrugGroupForm.vue?133e18d3